import React, { useState, useEffect } from "react";
import { Link, NavLink, useHistory } from "react-router-dom";
import Environment from "utils/environment";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import AssignOrder from "./AssignOrder";
import Offcanvas from 'react-bootstrap/Offcanvas';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
import Modal from "react-bootstrap/Modal";
import { useLocation } from "react-router-dom";

import Dropdown from 'react-bootstrap/Dropdown';

const OderDetaits = (props) => {
  const id = props.location.state.id;
  const location = useLocation();
  const { type } = location.state || {};
  const val = localStorage.getItem("accessToken");
  const api_url = Environment.base_url;
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  const [orderDetail, setOrderDetail] = useState([]);
  const [address, setAddress] = useState({});
  const [orderLines, setOrderLines] = useState([]);
  const [user, setUser] = useState({});
  const [productCount, setProductCount] = useState("");
  const [status, setStatus] = useState("");
  const [reciept, SetReciept] = useState([]);
  const [prescription, setPrescription] = useState([]);
  const [total, setTotal] = useState("");
  const [fee, setFee] = useState("");
  const [dis, setDis] = useState("");
  const [assignshow, setassignShow] = useState(false);
  const [status1, setstatus1] = useState('');
  const [deleteId, setDeleteId] = useState("");
  const [showbank, setShowBank] = useState(false);
  const [showPress, setShowPress] = useState(false);
  const handleCloseBank = () => setShowBank(false);
  const handleShowBank = () => setShowBank(true);
  const handleClosePress = () => setShowPress(false);
  const handleShowPress = () => setShowPress(true);
  const [date, setdate] = useState('');
  const statusOptions = ["pending", "processing", "delivered", "cancelled"];


   const statusConfig = {
    pending: { label: "Pending", className: "greenprocesssyellow", },
    processing: { label: "Confirmed", className: "greenprocesss" },
    delivered: { label: "Dispatched", className: "greenprocesssgreen" },
    cancelled: { label: "Cancelled", className: "greenprocesssred" }
  };


  const disabledMap = {
    processing: ["pending"],  
    delivered: ["pending", "processing", "cancelled"],
    cancelled: ["pending", "processing", "delivered"],
    refund: ["pending", "processing", "delivered", "cancelled"]
  };



  const getOrderDetails = async () => {
    setLoader(true);
    const config = {
      method: "get",
      url: api_url + "/orders/" + id,
      headers: {
        Authorization: "Bearer " + val,
      },
    };
    await axios(config)
      .then((res) => {
        const resData = res?.data;
        setOrderLines(resData?.data?.orderLines);
        console.log(resData?.data?.createdAt, 'createdAt')
        setdate(moment(resData?.data?.createdAt).format("DD MMM YYYY, h:mm A"));
        setAddress(resData?.data?.address);
        setProductCount(resData?.data?.productsCount);
        setStatus(resData?.data?.status);
        setUser(resData?.data?.user);
        SetReciept(resData?.data?.transactionReceiptImageUrl);
        setPrescription(resData?.data?.prescription)
        setTotal(resData?.data?.total);
        setFee(resData?.data?.deliveryFee);
        setDis(resData?.data?.discount?.discountAmount);
        setstatus1(resData?.data)

        console.log("details: ", resData);
        setLoader(false);
      })
      .catch((err) => {
        if (err?.response?.status == 501) {
          localStorage.removeItem("accessToken");
          history.push("/");
        } else if (err?.response?.status == 401) {
          localStorage.removeItem("accessToken");
          history.push("/");
          // FetchRefreshToken();
          console.log("refresh token: ", err?.response);
        }
        console.log("error meessage: ", err?.response?.data?.message);
        toast.error(err?.response?.data?.message, {
          position: "top-right",
          autoClose: 2000,
        });
        setLoader(false);
      });
  };

  useEffect(() => {
    if (!val) {
      history.push("/");
    } else {
      getOrderDetails();
    }
  }, []);

  const handlePrint = () => {
    window.print();
  };
  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  };





 

  const changeOrderStatus = async (id, status) => {
    const config = {
      method: "patch",
      url: api_url + "/orders/" + id + "/status",
      data: { status: status },
      headers: {
        Authorization: "Bearer " + val,
      },
    };

    await axios(config)
      .then((res) => {
        console.log("order status: ", res);
        toast.success(res?.data?.message);
       })
      .catch((error) => {
        if (error?.response?.status == 501) {
          toast.error("Jwt expired/invalid", {
            position: "top-right",
            autoClose: 3000,
          });
          localStorage.removeItem("accessToken");
          history.push("/");
        } else if (error?.response?.status == 401) {
          toast.error("Jwt expired/invalid", {
            position: "top-right",
            autoClose: 3000,
          });
          localStorage.removeItem("accessToken");
          history.push("/");
        } else {
          toast.error(error?.response?.data?.message, {
            position: "top-right",
            autoClose: 3000,
          });
        }
      });
  };















  return (
    <>
      <div className="content">
        <section className="main-dashboard">
          <div className="row">
            <div className="col-sm-12 p-0">
              <div className="Overview_odersec">
                <div className="twice-itemssss">
                  <h4 className="ooddeerr">

                    Order #9AF3DF <span className="innertagss"
                      style={{
                        background:
                          type === "pickUp"
                            ? "#E000AF"
                            : type === "standard"
                              ? "#615ACA" : "",
                        maxWidth:
                          type === "standard"
                            ? "128px" : "",

                      }}
                    >{type === 'pickUp' ? 'Self Pickup' : type === 'standard' ? 'Standard Delivery' : ''}</span></h4>
                  <div className="linksmainsss">
                    <a className="view-receipt" >View Receipt</a>
                    <a onClick={handleShow1} className="view-receipt view-receipttwo  ml-2" >View Prescription</a>
                    <a className="view-receipt view-receiptthree ml-2" >
                      <div className="dropdownsss">
                        <div className="">
                          <div className=" d-flex justify-content-start align-content-center">
                             
                            <Dropdown>
                              <Dropdown.Toggle
                                style={{
                                  fontSize: "12px",
                                  fontStyle: "normal",
                                  fontWeight: 500,
                                  lineHeight: "100%",
                                  borderRadius: "30px",
                                  background:
                                    status1.status === "pending"
                                      ? "#FFB800"
                                      : status1.status === "processing"
                                        ? "#009DE0"
                                        : status1.status === "delivered"
                                          ? "#00AE11"
                                          : status1.status === "cancelled" || status1.status === "refund"
                                            ? "#E15151"
                                            : "#E000AF",
                                  border: "none",
                                  maxWidth: "93px",
                                  color: "#fff",
                                  width: "100%",
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "5px 10px",
                                  justifyContent: "center"
                                }}
                                variant="success"
                                id="dropdown-basic"
                              >
                                <span title={status1.status}>
                                  {statusConfig[status1.status === "refund" ? "cancelled" : status1.status]?.label || status1.status}
                                </span>
                              </Dropdown.Toggle>

                              <Dropdown.Menu className="dropbody">
                                {statusOptions.map((status) => {
                                  const originalStatus = status1.status === "refund" ? "cancelled" : status1.status;
                                  const isDisabled =
                                    disabledMap[status1.status]?.includes(status) || originalStatus === status;

                                  return (
                                    <Dropdown.Item
                                      key={status}
                                      onClick={() => {
                                        if (!isDisabled) {
                                          changeOrderStatus(status1.id, status);
                                        }
                                      }}
                                      disabled={isDisabled}
                                      style={{
                                        color: isDisabled ? "red" : "black",
                                        cursor: isDisabled ? "not-allowed" : "pointer"
                                      }}
                                    >
                                      <input
                                        type="checkbox"
                                        checked={status === (status1.status === "refund" ? "cancelled" : status1.status)}
                                        readOnly
                                        className="mr-2"
                                      />
                                      {statusConfig[status]?.label}
                                    </Dropdown.Item>
                                  );
                                })}
                              </Dropdown.Menu>
                            </Dropdown>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                <div class="dropdown">
                   
                  <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <div className="input-field">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="defaultCheck1"
                      />
                      <label>All</label>
                    </div>
                    <div className="input-field">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        id="defaultCheck1"
                      />
                      <label>Unpublished</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table bashbord_table">
                  <thead className="bashbord_table_head">
                    <tr className="tablerow">
                      <th scope="col">ID</th>
                      <th scope="col">Customer</th>
                      <th scope="col">Phone No.</th>
                      <th scope="col">Address</th>
                      <th scope="col">Payment Method</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="fstrowtable">
                      <td>
                        <p className="fstrownum">{user?.id}</p>{" "}
                      </td>
                      <td className="avtimgandname">
                        <p className="fstrownumsec ">
                          {" "}
                          
                          {user?.name}
                        </p>
                      </td>
                      <td>
                        <p className="fstrownumthrd">{address?.contactNo}</p>
                      </td>
                      <td>
                        <p className="fstrownumfour">{address?.address}</p>

                        <span className="fstrownumfoursec">
                          {date}
                        </span>
                      </td>
                      <td>
                        <p className="fstrownumfive"> Bank transfer</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>





              <div class="table-responsive odertablelast">
                <table class="table bashbord_table">
                  <thead className="bashbord_table_head">
                    <tr className="tablerow tablerowheader">
                      <th>ID</th>
                      <th>PRODUCT NAME</th>
                      <th>CATEGORY</th>
                      <th>Discount</th>
                      <th>PRICE</th>
                      <th>after discount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Object.keys(orderLines).length > 0
                      ? Object.entries(orderLines).map(([key, val], item) => {
                        return (
                          <>
                            <tr className="fstrowtable">
                              <td>
                                <p className="fstrownum">{val?.id}</p>{" "}
                              </td>
                              <td className="avtimgandname">
                                <p className="fstrownumsec ">
                                  {" "}
                                  <img
                                    src={val?.product?.imageUrl}
                                    alt="img"
                                    className="avtartable  pr-2 img-fluid"
                                    style={{ width: '40px' }}
                                  />
                                  {val?.product?.name}
                                </p>
                              </td>
                              <td>
                                <p className="fstrownumthrd">
                                  Baby Care
                                </p>
                              </td>
                              <td>
                                <p className="fstrownumthrd">
                                  Yes
                                </p>
                              </td>
                              <td>
                                <p className="fstrownumfour">
                                  Rs. {val?.price}
                                </p>
                              </td>
                              <td>
                                {" "}
                                <span className="progressselling">
                                  Rs. 120
                                </span>
                              </td>
                            </tr>
                          </>
                        );
                      })
                      : null}

                    <tr className="fstrowtable">
                      <td>
                        <p className="fstrownum"></p>{" "}
                      </td>
                      <td className="avtimgandname">
                        <p className="fstrownumsec ">Total Amount</p>
                      </td>
                      <td>
                      </td>
                      <td>
                      </td>
                      <td>
                        <p className="fstrownumthrd">Rs. 1,801</p>
                      </td>
                      <td>
                        <p className="fstrownumfourPrimary">Rs.{Math.round(dis ? total + fee - dis : total + fee)}</p>
                      </td>
                      <td>
                        {" "}
                        <span className=""></span>
                      </td>
                    </tr>


                  </tbody>
                </table>
              </div>
            </div>
          </div>

        </section>
        <AssignOrder assignshow={assignshow} setassignShow={setassignShow} />
      </div>
      <Offcanvas className="banktransfer-sidebar" show={showbank} onHide={handleCloseBank}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Bank Transfer</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {reciept ? (<div className="reciept-img">
            <img src={reciept} alt="img" className="img-fluid" />
          </div>) : (<div className="reciept-img">
            <p style={{ color: 'gray', textAlign: 'center', fontSize: '16px' }}>No Image Uploaded</p>
          </div>)}
          <button className="btn-reject " onClick={handlePrint}>Print</button>
        </Offcanvas.Body>
      </Offcanvas>


      <Offcanvas className="banktransfer-sidebar" show={showPress} onHide={handleClosePress}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Prescription</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {prescription ? (<div className="reciept-img">

            <img src={prescription[0]} alt="img" className="img-fluid" />

          </div>) : (<div className="reciept-img">
            <p style={{ color: 'gray', textAlign: 'center', fontSize: '16px' }}>No Image Uploaded</p>
          </div>)}
          <button className="btn-reject " onClick={handlePrint}>Print</button>
        </Offcanvas.Body>
      </Offcanvas>

      <Modal className="mainmodalbanner" show={show1} onHide={handleClose1} centered>
        <Modal.Body className="modalbodyprnt">
          <Slider {...settings}>
            {/* <img className='img-fluid' src="\Products\fruits.jpg" alt="" /> */}
            {prescription ?
              <img src={prescription[0]} alt="img" className="img-fluid" /> : (
                <>
                  <img src="\Products\fruits.jpg" alt="img" />
                  <img src="\Products\fruits.jpg" alt="img" />
                  <img src="\Products\fruits.jpg" alt="img" />
                </>
              )

            }

          </Slider>
        </Modal.Body>
      </Modal>

    </>
  );
};

export default OderDetaits;
